import React from 'react';

const founders = [
  {
    name: "Philippe Alexis",
    role: "Co-fondateur VIVANT",
    domain: "DRIVE & ART DE VIVRE",
    domainDesc: "Cayenne Experience • Villa • Lifestyle",
    bio: "Entrepreneur, fondateur du Palazzo Hotel et de Vivre Marrakech. Ex-pilote automobile, créateur de RPM Garage. Philippe incarne l'alliance entre adrénaline et art de vivre.",
    achievements: ["Palazzo Hotel", "Vivre Marrakech", "RPM Garage", "Ex-pilote"],
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/jctyzvun_images.jpeg",
  },
  {
    name: "Sabril Jurczeszyn",
    role: "Co-fondateur VIVANT",
    domain: "TRAIN & WORK",
    domainDesc: "Combat • Stratégie • Opérations",
    bio: "Fondateur de MAISON AVOCADO, 360 Resto et Zebra Gang. Expert hôtellerie-restauration, ex-publicitaire. Pratiquant de sports de combat. Sabril apporte la discipline et la vision stratégique.",
    achievements: ["MAISON AVOCADO", "360 Resto", "Zebra Gang", "Ex-publicitaire"],
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/9yc1iys5_1683574321261.jpeg",
  }
];

const FoundersSection = () => {
  return (
    <section className="bg-black py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-4">LES FONDATEURS</p>
          <h2 className="font-italiana text-3xl md:text-4xl lg:text-5xl tracking-[0.1em] text-white mb-4">
            Ceux qui ont créé <span className="text-[#D4A574]">VIVANT</span>
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-2xl mx-auto">
            Entrepreneurs, passionnés, exigeants. Ils ont conçu l'expérience qu'ils auraient aimé vivre.
          </p>
        </div>

        {/* Founders Grid */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {founders.map((founder, index) => (
            <div 
              key={founder.name}
              className="group relative bg-white/5 border border-white/10 rounded-2xl p-8 hover:border-[#D4A574]/30 transition-all duration-300"
            >
              {/* Photo placeholder */}
              <div className="relative w-32 h-32 md:w-40 md:h-40 mx-auto mb-6">
                <div className="w-full h-full rounded-full bg-gradient-to-br from-[#D4A574]/30 to-[#D4A574]/10 border-2 border-[#D4A574]/30 flex items-center justify-center overflow-hidden">
                  {founder.image ? (
                    <img 
                      src={founder.image} 
                      alt={founder.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="font-italiana text-4xl md:text-5xl text-[#D4A574]">
                      {founder.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  )}
                </div>
                {/* Decorative ring */}
                <div className="absolute inset-0 rounded-full border border-[#D4A574]/20 scale-110 group-hover:scale-115 transition-transform duration-300" />
              </div>

              {/* Info */}
              <div className="text-center">
                <h3 className="font-italiana text-2xl md:text-3xl tracking-[0.08em] text-white mb-1">
                  {founder.name}
                </h3>
                <p className="text-[#D4A574] text-xs tracking-[0.2em] mb-2">{founder.role}</p>
                
                {/* Domain badge */}
                <div className="mb-4">
                  <span className="inline-block bg-[#D4A574]/10 border border-[#D4A574]/30 text-[#D4A574] text-[10px] tracking-[0.15em] font-medium px-3 py-1.5 rounded-full">
                    {founder.domain}
                  </span>
                  <p className="text-white/40 text-xs mt-2">{founder.domainDesc}</p>
                </div>
                
                <p className="text-white/60 text-sm leading-relaxed mb-6">
                  {founder.bio}
                </p>

                {/* Achievements tags */}
                <div className="flex flex-wrap justify-center gap-2">
                  {founder.achievements.map((achievement) => (
                    <span 
                      key={achievement}
                      className="text-[10px] tracking-wider px-3 py-1 rounded-full bg-white/5 border border-white/10 text-white/50"
                    >
                      {achievement}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom quote */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white/5 border border-white/10 rounded-2xl px-8 py-6 max-w-3xl">
            <svg className="w-8 h-8 text-[#D4A574]/30 mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>
            <p className="text-white/70 text-base md:text-lg italic leading-relaxed">
              "On a créé VIVANT parce qu'on en avait besoin nous-mêmes. Un lieu pour se ressourcer, se challenger, et repartir plus fort. Pas de bullshit, juste du concret."
            </p>
            <p className="text-[#D4A574] text-sm mt-4 tracking-wider">— Philippe & Sabril</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
